module.exports = __webpack_public_path__ + "img/_icon-schedule-pickup.db99f000.svg";